import { menuItems } from "./menus.js";
import MenuItems from "./MenuItems";
import "./Navbar.css";
import React, { useState, useEffect, useRef } from "react";
import * as FaIcons from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

import { faSignOut } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import menubar from "../pages/img/icon/menubar.png";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import dompurify from "dompurify";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);
  const [menus, setNavbar] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [show, setShow] = useState(false);

  /* 언어 변경 */
  const [selectedLang, setLanguage] = useState();
  const [korean, setKor] = useState(false);
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language.current === undefined || language.current === null) {
      language.current = cookies.get("language");
      if (language.current === undefined || language.current === null) {
        language.current = "kr-KR";
      }
    }
    console.log(language.current);

    i18next.changeLanguage(language.current);
    setLanguage(language.current);

    if (language.current === "kr-KR") {
      setKor(true);
    } else {
      setKor(false);
    }
  }, []);
  //언어 변경 시 변경된 언어 쿠키로 저장
  const onChangeHandler = (event) => {
    var selected = event.currentTarget.dataset.id;
    sessionStorage.setItem("language", selected);
    cookies.set("language", selected, { path: "/", maxAge: 3600 });
    i18next.changeLanguage(selected);

    sessionStorage.setItem("language", selected);
    cookies.set("language", selected, { path: "/", maxAge: 3600 });
    i18next.changeLanguage(selected);

    window.location.reload();
  };
  //언어 변경 시 변경된 언어 쿠키로 저장-모바일 ver.
  const onChangeHandlerMobile = (event) => {
    var selected = event.currentTarget.value;
    sessionStorage.setItem("language", selected);
    cookies.set("language", selected, { path: "/", maxAge: 3600 });
    i18next.changeLanguage(selected);

    sessionStorage.setItem("language", selected);
    cookies.set("language", selected, { path: "/", maxAge: 3600 });
    i18next.changeLanguage(selected);

    window.location.reload();
  };
  /*mobile menu 열리는 기능*/
  const showSidebar = () => {
    setSidebar(!sidebar);
    //모바일 메뉴가 열려있을 땐 body 길이에 따라 스크롤이 안나타나도록 방지
    if (sidebar===false){
      document.body.style.overflow = "hidden";
    }else {
      document.body.style.overflow = "visible";
    }
  };
  /* 스크롤 시 메뉴 sticky 메뉴로 변경 */
  const [stickyClass, setStickyClass] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);

    return () => {
      window.removeEventListener("scroll", stickNavbar);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 50
        ? setStickyClass("fixed top-0 left-0 z-50")
        : setStickyClass("relative");
    }
  };

  /*메뉴 hover 시 하단 메뉴 show/hide */

  const showSubmenu = () => {

  };
  const hideSubmenu = () => {

  };

  /* 모바일 각 메뉴 별(ex:회사소개, 제품소개, ...) 화살표 효과 주기 위함 */

  const [isActive, setIsActive] = useState(false);

  const handleClick = (event) => {
    // 회사소개
    setIsActive((current) => !current);
    setIsActive2(false);
    setIsActive3(false);
    setIsActive4(false);
  };
  const [isActive2, setIsActive2] = useState(false);

  const handleClick2 = (event) => {
    // 제품정보
    setIsActive2((current) => !current);
    setIsActive(false);
    setIsActive3(false);
    setIsActive4(false);
  };
  const [isActive3, setIsActive3] = useState(false);

  const handleClick3 = (event) => {
    // PR센터
    setIsActive3((current) => !current);
    setIsActive(false);
    setIsActive2(false);
    setIsActive4(false);
  };
  const [isActive4, setIsActive4] = useState(false);

  const handleClick4 = (event) => {
    // 고객센터
    setIsActive4((current) => !current);
    setIsActive2(false);
    setIsActive3(false);
    setIsActive(false);
  };

  return (
    <div>
      <nav
        //className={`${stickyClass}`}
        onMouseEnter={showSubmenu}
        onMouseLeave={hideSubmenu}
      >
        <header>
          <a href="/" className="logo">
            <div className="logoImg"></div>
          </a>

          <div
            className="menus_wrap"
            style={{ display: "flex", justifyContent: "center", width: "60%" }}
          >
            <div className={menus ? "menus active" : "menus"}>
              <a href="/ceo">
                <span>{i18next.t("navbar.1")}</span>

                <div className="submenu">
                
                  <li><a href="/ceo">{i18next.t("navbar.1-1")}</a></li>
                
                
                  {/*<li><a href="/overview">회사개요</a></li>*/}
                
                
                  <li><a href="/history">{i18next.t("navbar.1-2")}</a></li>
              
                
                  <li><a href="/location">{i18next.t("navbar.1-3")}</a></li>
               

                </div>
              </a>
              <a href="/software">
                <span>{i18next.t("navbar.2")}</span>

                <div className="submenu">
                  <li>
                  <a href="/software">
                  {i18next.t("navbar.2-1")}
                  </a>  
                  </li>
                
                
                  <li>
                  <a href="/device">{i18next.t("navbar.2-2")}</a></li>
                
                
                  <li><a href="/medicine">{i18next.t("navbar.2-3")}</a></li>
                
                </div>
              </a>
              <a href="/news">
                <span>{i18next.t("navbar.3")}</span>

                <div className="submenu">
                
                  <li><a href="/news">{i18next.t("navbar.3-1")}</a></li>
                  
                </div>
              </a>
              <a href="/inquiry">
                <span>{i18next.t("navbar.4")}</span>

                <div className="submenu">
                
                  <li><a href="/inquiry">{i18next.t("navbar.4-1")}</a></li>
                
            
                
                  <li><a href="/career">{i18next.t("navbar.4-2")}</a></li>
           
                </div>
                
              </a>
            </div>
          </div>

          <div className="navRight">
            <div className="navRight-wrap">
              <div className="lang-menu">
                <div className="selected-lang">
                  <div
                    className="globe"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginRight: "10px",
                      backgroundSize: "contain",
                    }}
                  ></div>
                  {selectedLang}
                </div>
                <ul>
                  <li onClick={onChangeHandler} data-id="kr-KR">
                    <a>한국어</a>
                  </li>
                  <li onClick={onChangeHandler} data-id="en-US">
                    <a>English</a>
                  </li>
                
                </ul>

                <div
                  className="header_arrow"
                  style={{
                    width: "22px",
                    marginRight: "10px",
                    height: "22px",
                    backgroundPosition: "center center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </header>

    
      </nav>
      {/* 모바일 ver 메뉴 */}
      <div className="mobileNav-bar">
        <div className={scrollPosition < 90 ? "mobileNav" : "change_mobileNav"}>
          <a href="/" className="mobileNav-home">
            <div className="mobile_logo"></div>
          </a>
          <Link to="#" className="menu-bars">
            <img
              src={menubar}
              alt="menu_bar"
              style={{ width: "27px" }}
              onClick={showSidebar}
            ></img>
          </Link>
          <div
            className="mobile_lang"
            style={{ width: "50px", position: "absolute", right: "15px" }}
          >
            <div className="mobile_sel">
              <select
                title="언어 선택"
                className="LanguageToggle-select ty-c1"
                value={selectedLang}
                onChange={onChangeHandlerMobile}
              >
                <option data-lang-code="kr" value="kr-KR">
                  KR
                </option>
                <option data-lang-code="en" value="en-US">
                  EN
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className={sidebar ? "nav-menu active" : "nav-menu"}>
          <div className="menu-wrapper">
            <ul className="menu-mobile">
              <li
                className={isActive ? "nav-text active" : "nav-text"}
                onClick={handleClick}
              >
                <span>{i18next.t("navbar.1")}</span>

                <ul className="sub-menu-mobile">
                  <li>
                    <a href="/ceo">{i18next.t("navbar.1-1")}</a>
                  </li>

                  {/*<li>
                    <a href="/overview">-개요</a>
                </li>*/}

                  <li>
                    <a href="/history">{i18next.t("navbar.1-2")}</a>
                  </li>
                  <li>
                    <a href="/location">{i18next.t("navbar.1-3")}</a>
                  </li>
                </ul>
              </li>

              <li
                className={isActive2 ? "nav-text active" : "nav-text"}
                onClick={handleClick2}
              >
                <span>{i18next.t("navbar.2")}</span>
                <ul className="sub-menu-mobile">
                  <li>
                    <a href="/software">{i18next.t("navbar.2-1")}</a>
                  </li>

                  <li>
                    <a href="/device">{i18next.t("navbar.2-2")}</a>
                  </li>

                  <li>
                    <a href="/medicine">{i18next.t("navbar.2-3")}</a>
                  </li>
                </ul>
              </li>

              <li
                className={isActive3 ? "nav-text active" : "nav-text"}
                onClick={handleClick3}
              >
                <span>{i18next.t("navbar.3")}</span>

                <ul className="sub-menu-mobile">
                  <li>
                    <a href="/news">{i18next.t("navbar.3-1")}</a>
                  </li>

                 
                </ul>
              </li>

              <li
                className={isActive4 ? "nav-text active" : "nav-text"}
                onClick={handleClick4}
              >
                <span>{i18next.t("navbar.4")}</span>
                <ul className="sub-menu-mobile">
                  <li>
                    <a href="/inquiry">{i18next.t("navbar.4-1")}</a>
                  </li>

                 {/*} <li>
                    <a href="/as">-A/S접수</a>
                  </li>
              */}
                  <li>
                    <a href="/career">{i18next.t("navbar.4-2")}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
